import { render, staticRenderFns } from "./downloadApp_themeTwo.vue?vue&type=template&id=2fbde6a2&scoped=true"
import script from "./downloadApp_themeTwo.vue?vue&type=script&lang=js"
export * from "./downloadApp_themeTwo.vue?vue&type=script&lang=js"
import style0 from "./downloadApp_themeTwo.vue?vue&type=style&index=0&id=2fbde6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbde6a2",
  null
  
)

export default component.exports